import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="py-20 bg-gray-50 min-h-screen flex items-center">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <Card>
              <CardContent className="py-12 text-center">
                <XCircle className="h-16 w-16 text-gray-400 mx-auto mb-6" />
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Checkout Cancelled
                </h2>
                <p className="text-xl text-gray-600 mb-8">
                  Your order was not completed. No charges were made.
                </p>
                <p className="text-gray-600 mb-8">
                  Your cart items have been saved. You can return to complete your purchase anytime.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link to="/cart">
                    <Button className="bg-amber-600 hover:bg-amber-700 text-white" size="lg">
                      Return to Cart
                    </Button>
                  </Link>
                  <Link to="/store">
                    <Button variant="outline" size="lg">
                      Continue Shopping
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CheckoutCancel;
